import type { ZeytalCLIPureConfig } from "@zeytal/kit";

import { prepareAssetForTransit } from "../processors/index.ts";

import { optimizeSvg } from "./svg.ts";

export const optimizeAsset = (
  userConfig: ZeytalCLIPureConfig,
  assetName: string,
  assetData: Buffer,
) => {
  const [assetType] = assetName.split("/");
  let optimizedAssetData = assetData;

  if (assetType === "svg") {
    optimizedAssetData = optimizeSvg(userConfig, assetName, assetData);
  }

  return prepareAssetForTransit(optimizedAssetData);
};
